import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";
import ScrollProgress from "@/components/site/ScrollProgress";
import BackToTop from "@/components/site/BackToTop";
import StickyApplyCTA from "@/components/site/StickyApplyCTA";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Packages from "@/pages/Packages";
import Hosting from "@/pages/Hosting";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Quote from "@/pages/Quote";
import Apply from "@/pages/Apply";
import Intake from "@/pages/Intake";
import IntakeNext from "@/pages/IntakeNext";
import Consultation from "@/pages/Consultation";
import ThankYou from "@/pages/ThankYou";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import "@/App.css";

// Code-split heavier / rarely-visited routes to shrink the initial bundle.
const Portfolio = lazy(() => import("@/pages/Portfolio"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));

function RouteFallback() {
  return (
    <div className="min-h-[60vh] grid place-items-center text-gray-500 text-sm" data-testid="route-loading">
      Loading…
    </div>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#05050a] text-white antialiased">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <ScrollProgress />
          <Navbar />
          <main className="pt-20">
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/hosting" element={<Hosting />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/apply" element={<Apply />} />
                <Route path="/intake/:packageId" element={<Intake />} />
                <Route path="/intake/:packageId/next" element={<IntakeNext />} />
                <Route path="/consultation" element={<Consultation />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <BackToTop />
          <StickyApplyCTA />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
